import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { Toaster } from 'sonner';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import { AppProvider } from './context/AppContext';
import { ToastContextProvider } from './context/ToastContext';
import { ErrorBoundary } from './components/ErrorBoundary';
import { GlobalStyle, theme } from './styles/GlobalStyles';
import './index.css';
import { AppRouter } from './components/AppRouter';

const AppContent = () => {
  return (
    <>
      <GlobalStyle />
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: '#121212',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            color: '#fff',
          },
          classNames: {
            success: 'toast-success',
            error: 'toast-error',
            info: 'toast-info',
            warning: 'toast-warning',
          },
        }}
      />
      <Router>
        <AppRouter />
      </Router>
    </>
  );
};

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <StyledThemeProvider theme={theme}>
          <AuthProvider>
            <AppProvider>
              <ToastContextProvider>
                <AppContent />
              </ToastContextProvider>
            </AppProvider>
          </AuthProvider>
        </StyledThemeProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
